var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 63,
    viewBox: "0 0 72 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7384 47.6445C29.7384 56.6766 23.254 63 14.9813 63C6.26162 63 0 56.4516 0 47.6445C0 43.3549 0.895544 39.9667 4.02492 31.6125L14.5343 0H28.6215L20.3474 33.6463C26.162 35.6786 29.7384 40.6461 29.7384 47.6459V47.6445ZM72 47.6445C72 56.6766 65.5141 63 57.2415 63C48.5218 63 42.2602 56.4516 42.2602 47.6445C42.2602 43.3549 43.1543 39.9667 46.2851 31.6125L56.7944 0H70.8816L62.6076 33.6463C68.4207 35.6786 71.9986 40.6461 71.9986 47.6459L72 47.6445Z",
    fill: "#DFDFDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationMark);
export default __webpack_public_path__ + "static/media/QuotationMark.41eb8fdcd614f6177fa97950251c6688.svg";
export { ForwardRef as ReactComponent };